import { ToolbarState } from './State'
import { DOWNLOADING_PDF, TOGGLE_SOCIAL_MEDIA_BUTTON_DIALOG_OPEN, ToolbarAction } from './Actions'

function toolbarReducer(state: ToolbarState, action: ToolbarAction): ToolbarState {
  switch (action.type) {
    case DOWNLOADING_PDF:
      return Object.assign({}, state, { downloadingPDF: action.payload })
    case TOGGLE_SOCIAL_MEDIA_BUTTON_DIALOG_OPEN: {
      return {
        ...state,
        isSocialMediaButtonDialogOpen: action.payload
      }
    }
    default:
      return state
  }
}

export default toolbarReducer
